import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxAddressComponent,
  OnyxDataWidgetComponent,
  OnyxInformationHeadingComponent,
  OnyxLinkComponent,
} from '@onyx/angular';
import { ModalLoadingSectionComponent } from '../../../../../../common/components/modals/modal-loading-section/modal-loading-section.component';
import { TelematicsStore } from '../../../../../../common/stores/telematics.store';
import { SwapModalHelper } from '../../../../../map/common/helpers/swap/swap-modal.helper';
import { OrderHelper } from '../../../../common/helpers/order.helper';
import type { Order } from '../../../../common/interfaces/order';
import type { RelatedFleetSwap } from './../../../../../../common/interfaces/common/related-fleet-swap';

@Component({
  selector: 'app-order-modal-planned-swap-point',
  imports: [
    OnyxDataWidgetComponent,
    OnyxAddressComponent,
    ModalLoadingSectionComponent,
    OnyxLinkComponent,
    TranslatePipe,
    OnyxInformationHeadingComponent,
  ],
  templateUrl: './order-modal-planned-swap-point.component.html',
  styleUrl: './order-modal-planned-swap-point.component.scss',
})
export class OrderModalPlannedSwapPointComponent {
  protected readonly telematicsStore = inject(TelematicsStore);
  private readonly swapModalHelper = inject(SwapModalHelper);

  public readonly order = input.required<Order>();
  public readonly relatedFleetSwap = input.required<RelatedFleetSwap>();

  protected missingAssignment = computed(() =>
    OrderHelper.getMissingAssignment(this.order()),
  );
  protected swapPointAddress = computed(
    () =>
      this.telematicsStore
        .swapPointsBySwapUuid()
        .get(this.relatedFleetSwap().uuid)
        ?.at(0)?.address ?? null,
  );

  protected openSwapModal(uuid: string): void {
    this.swapModalHelper.openModal(
      uuid,
      this.order().assignedData?.vehicle?.uuid ?? null,
    );
  }
}
